export class NotFoundException extends Error {
  code = 'PM-0404';

  constructor(message = 'Webpage not found.') {
    super(message);
  }
}
